import { RenderProps, TranslationController } from '@nackle/translation-editor/src/TranslationController';
import config from 'app/config';
import { getDelegatedOrCurrentCompanyId, getSessionId } from 'app/dux/session/selectors';
import { AppState } from 'app/store/reducers';
import noop from 'lodash/noop';
import React, { Component, ReactNode } from 'react';
import { connect } from 'react-redux';

function mapStateToProps(state: AppState) {
    return {
        accessToken: getSessionId(state),
        companyId: getDelegatedOrCurrentCompanyId(state),
    };
}

interface PropsFromRedux {
    accessToken: string;
    companyId: string;
}

interface ExternalProps {
    children: (props: RenderProps) => ReactNode;
    keyName: string;
}

export class TranslationControllerWrapperImpl extends Component<ExternalProps & PropsFromRedux> {
    render() {
        const {
            accessToken,
            children,
            companyId,
            keyName,
        } = this.props;

        if (!accessToken) {
            return children({
                canEdit: false,
                isLoaded: false,
                label: keyName,
                openerProps: {
                    onClick: noop,
                }
            });
        }

        return (
            <TranslationController
                authToken={accessToken}
                cmxApiUrl={config.CMX_API_URL}
                companyId={companyId}
                keyName={keyName}
                project={config.PROJECT_NAME}
            >
                {children}
            </TranslationController>
        );
    }
}

export const TranslationControllerWrapper = connect(mapStateToProps)(TranslationControllerWrapperImpl);
